import React, { useEffect } from "react";
import HeroSection from "./HeroSection";
import ProductDetails from "./ProductDetails";
import Benefits from "./Benefits";
import FAQSection from "./FAQSection";

import Images from "./Images";
import img1 from "../assets/childernseafty/1.jpg";
import img2 from "../assets/childernseafty/2.jpg";
import img3 from "../assets/childernseafty/3.jpg";
import main from "../assets/childernseafty/main.jpg";
import { Helmet } from "react-helmet-async";

export default function ChildrenSafetyNets() {
       useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Children safety Nets installation Bengaluru/bangalore call us 7416116587",
    url: "https://www.anssafetynets.com/childernsafetynets",
    description:
      "Protect your little ones with our premium children’s safety nets, designed for comprehensive childproofing of your home or commercial space. Whether it's preventing falls from balconies, staircases, beds, or ensuring safe play zones in playgrounds or schools, our safety nets are built with high-tensile, non-toxic, and UV-resistant materials that ensure durability and reliability. Easy to install and maintain, these nets seamlessly blend with your surroundings without compromising the aesthetics of your space",
    keywords: [
      "buy child safety nets online",
      "affordable baby safety nets",
      "best kids safety nets for home",
      "balcony safety net installation near me",
      "anti-fall net for children",
      "custom safety nets for children",
      "child safety nets in Bengaluru",
      "safety net installers near me",
      "kids balcony net services Bangalore city",
      "children safety nets Bengaluru",
    ],
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.anssafetynets.com",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Children Safety Nets",
          item: "https://www.anssafetynets.com/childernsafetynets",
        },
      ],
    },
    publisher: {
      "@type": "Organization",
      name: "ANS Safety Nets",
      logo: {
        "@type": "ImageObject",
        url: "https://www.anssafetynets.com/logo.png",
        width: 250,
        height: 100,
      },
      contactPoint: [
        {
          "@type": "ContactPoint",
          telephone: "+91-7416116587",
          contactType: "Customer Service",
          areaServed: "IN",
          availableLanguage: ["English", "Kannada"],
        },
      ],
      sameAs: [
        "https://www.facebook.com/profile.php?id=61572534324956",
        "https://www.instagram.com/anssafetynets_bengaluru/",
      ],
    },
    mainEntity: {
      "@type": "Organization",
      name: "ANS Safety Nets",
      address: {
        "@type": "PostalAddress",
        streetAddress:
          "74/9, 5th Cross Rd, Muthyala Nagar, Bahubali Nagar, Jalahalli, Bengaluru, Karnataka 560013",
        addressLocality: "Bengaluru",
        addressRegion: "KA",
        postalCode: "560013",
        addressCountry: "IN",
      },
      service: [
        {
          "@type": "Service",
          name: "Children Safety Nets",
          areaServed: "Bengaluru",
        },
      ],
    },
  };
  return (
    <div>
      <Helmet>
        <title>
          Children safety Nets installation Bengaluru/bangalore call us
          7416116587
        </title>
        <meta
          name="description"
          content="Protect your little ones with our premium children’s safety nets, designed for
comprehensive childproofing of your home or commercial space. Whether it's preventing
falls from balconies, staircases, beds, or ensuring safe play zones in playgrounds or
schools, our safety nets are built with high-tensile, non-toxic, and UV-resistant materials
that ensure durability and reliability. Easy to install and maintain, these nets seamlessly
blend with your surroundings without compromising the aesthetics of your space"
        />
        <meta
          name="keywords"
          content="Buy child safety nets online
Affordable baby safety nets
Best kids safety nets for home
Balcony safety net installation near me
Anti-fall net for children
Custom safety nets for children
Child safety nets in Bengaluru
Safety net installers near me 
Kids balcony net services bangalore city
Children safety nets Bengaluru"
        />
        <meta name="author" content="ANS Safety Nets, Bengaluru" />
        <link
          rel="canonical"
          href="https://www.anssafetynets.com/childernsafetynets"
        />
        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      </Helmet>

      <HeroSection
        title="Children Safety Nets"
        description="Safety nets designed to keep children safe from accidental falls."
        bgColor="bg-[#2c3639]"
      />

      <ProductDetails
        title="Why Choose Our Children Safety Nets?"
        content="At ANS Safety Nets, we understand the importance of keeping your children safe while they enjoy outdoor activities. Our children's safety nets are made from premium, durable materials that provide reliable protection against accidental falls and other safety hazards. Designed to withstand various weather conditions, our safety nets offer peace of mind, allowing your little ones to play freely without worry. Whether it's for balconies, windows, or playgrounds, our child safety nets are customized to fit your specific needs, ensuring a secure and safe environment. With ANS Safety Nets, you can trust that your loved ones are protected, allowing them to enjoy the outdoors with complete peace of mind."
        image={main}
      />

      <Images images={[img1, img2, img3]} />

      <Benefits
        benefits={[
          {
            title: "Child Protection",
            description:
              "Protect children from accidental falls while playing.",
          },
          {
            title: "Durable Materials",
            description:
              "Our nets are built to last and can withstand harsh weather.",
          },
          {
            title: "Easy Installation",
            description: "Quick and easy setup, perfect for home use.",
          },
        ]}
      />

      <FAQSection
        faqs={[
          {
            question: "What materials are used in your safety nets?",
            answer:
              "Our nets are made from high-strength nylon, ensuring durability.",
          },
          {
            question: "Can the nets be used for indoor areas?",
            answer:
              "Yes, they are versatile and can be installed indoors or outdoors.",
          },
        ]}
      />
    </div>
  );
}
